export default __webpack_public_path__ + "static/img-art-pandas-profiling-4-3b5946c552e0b41b3035f365e0e6600d.webp";